// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  pages: icon("ic_pages"),
  blogs: icon("ic_blogs"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  contacts: icon("ic_contacts"),
  testimonials: icon("ic_testimonials"),
  school: icon("ic_school"),
  dress: icon("ic_dress"),
  size: icon("ic_size"),
  category: icon("ic_category"),
  house: icon("ic_house"),
};

const navConfig = [
  // analytics
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
      { title: "Profile", path: PATH_DASHBOARD.profile, icon: ICONS.profile },
      // { title: 'Notifications', path: PATH_DASHBOARD.notification, icon: ICONS.notification },
    ],
  },

  // TODO: entriessss
  {
    subheader: "Carnation Entries",
    items: [
      {
        title: "Carnation Entries",
        path: PATH_DASHBOARD.entries.root,
        icon: ICONS.school,
        children: [
          {
            title: "Schools",
            path: PATH_DASHBOARD.entries.schools.root,
            // icon: ICONS.school,
            children: [
              {
                title: "School list",
                path: PATH_DASHBOARD.entries.schools.list,
              },
              { title: "Add School", path: PATH_DASHBOARD.entries.schools.add },
            ],
          },

          {
            title: "Dresses",
            path: PATH_DASHBOARD.entries.dresses.root,
            // icon: ICONS.dress,
            children: [
              {
                title: "Dresses list",
                path: PATH_DASHBOARD.entries.dresses.list,
              },
              { title: "Add Dress", path: PATH_DASHBOARD.entries.dresses.add },
            ],
          },

          {
            title: "Sizes",
            path: PATH_DASHBOARD.entries.sizes.root,
            // icon: ICONS.size,
            children: [
              {
                title: "Sizes list",
                path: PATH_DASHBOARD.entries.sizes.list,
              },
              {
                title: "Add Size",
                path: PATH_DASHBOARD.entries.sizes.add,
              },
            ],
          },
          {
            title: "Categories",
            path: PATH_DASHBOARD.entries.categories.root,
            // icon: ICONS.category,
            children: [
              {
                title: "Categories list",
                path: PATH_DASHBOARD.entries.categories.list,
              },
              {
                title: "Add Category",
                path: PATH_DASHBOARD.entries.categories.add,
              },
            ],
          },

          {
            title: "Houses",
            path: PATH_DASHBOARD.entries.houses.root,
            // icon: ICONS.house,
            children: [
              {
                title: "Houses list",
                path: PATH_DASHBOARD.entries.houses.list,
              },
              {
                title: "Add House",
                path: PATH_DASHBOARD.entries.houses.add,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    subheader: "Contact",
    items: [
      {
        title: "Contacts",
        path: PATH_DASHBOARD.contacts.root,
        icon: ICONS.contacts,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "management",
    items: [
      {
        title: "Help and Support",
        path: PATH_DASHBOARD.manage.root,
        icon: ICONS.user,
        children: [{ title: "FAQs", path: PATH_DASHBOARD.manage.faqs }],
      },
    ],
  },
];

export default navConfig;
